<template>
  <div class="w-3/4 mt-4 text-zt-dark-400 flex justify-between items-center">
    <zt-icon class="text-3xl" name="file"/>
    <span class="flex-none mx-2">{{ $t('message.abm.folders.pdfInfo.size') }} {{ document.paper }}</span>
    <span class="mr-2">|</span>
    <span class="mr-2">{{ $t('message.abm.folders.pdfInfo.page') }}</span>
    <input
      class="outline-none px-2 mr-2"
      @change="setCustomPage"
      @input="regexDigit"
      :key="keyRenderer"
      :value="value"
      data-vs-input="setCustomPage"
    />
    <span class="mr-2">/</span>
    <span class="mr-2">{{ totalPages }}</span>
    <button class="flex justify-between items-center" :disabled="disabledPrev" @click="prevPage" data-vs-button="prevPage">
      <zt-icon name="angle-left" />
    </button>
    <button class="flex justify-between items-center" :disabled="disabledNext" @click="nextPage" data-vs-button="nextPage">
      <zt-icon name="angle-right" />
    </button>
  </div>
</template>
<script>
export default {
  name: "PdfInfo",
  inject: ['updateVisorPDF'],
  props: {
    document: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      pageNumber: 1,
      keyRenderer: 0
    }
  },
  computed: {
    value() {
      const { page } = this.document
      const numberPage = page.pdfPage.pageNum
      return numberPage < 10 ? `0${numberPage}`: numberPage.toString()
    },
    disabledPrev() {
      const { page } = this.document
      return page && page.pdfPage.pageNum === 1
    },
    disabledNext() {
      const { page, document: { _pdfInfo } } = this.document
      return page && page.pdfPage.pageNum === _pdfInfo.numPages
    },
    totalPages() {
      const { document: { _pdfInfo } } = this.document
      return _pdfInfo && _pdfInfo.numPages
    }
  },
  methods: {
    setCustomPage(e) {
      if (!e.target.value) return
      const { document: { _pdfInfo } } = this.document
      let numberPage = parseInt(e.target.value)
      if (numberPage > _pdfInfo.numPages) {
        numberPage = parseInt(this.pageNumber)
        this.keyRenderer += 1
      }
      if (numberPage < 1) numberPage = 1
      this.pageNumber = numberPage
      this.updateVisorPDF({ page: numberPage })
    },
    prevPage() {
      const { page } = this.document
      if (page.pdfPage.pageNum > 1) {
        const numberPage = page.pdfPage.pageNum - 1
        this.pageNumber = numberPage
        this.updateVisorPDF({ page: numberPage })
      }
    },
    nextPage() {
      const { page, document: { _pdfInfo } } = this.document
      if (page.pdfPage.pageNum < _pdfInfo.numPages) {
        const numberPage = page.pdfPage.pageNum + 1
        this.pageNumber = numberPage
        this.updateVisorPDF({ page: numberPage })
      }
    },
    regexDigit(e) {
      e.target.value = e.target.value.replace(/[^0-9]/g, '')
    }
  }
}
</script>
<style scoped>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
  opacity: .7;
}
input {
  border: solid 1px #6f6f6f;
  width: 3.5rem;
}
</style>